// extracted by mini-css-extract-plugin
export default {"swiperslide":"DaySelector_swiperslide__MikEv","swiperStyles":"DaySelector_swiperStyles__AFzRR"};